var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-2"},[(_vm.loadingTable)?_c('div',{staticClass:"d-flex justify-content-center w-100",staticStyle:{"margin-top":"110px"}},[_c('loading')],1):_c('div',[_c('planificacion-semanal-tabla')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }